export enum VetsuiteApi {
  Prismatic = 'https://hooks.prismatic.io/trigger/SW5zdGFuY2VGbG93Q29uZmlnOjk3N2Q3NTFiLWQzYzgtNDc4NC1hNjI0LTgyNzE5YWI1MWI5YQ==',
  CatalogCustomers = '/account/catalogSearch',
  VetSuiteCustomers = '/account/search',
  DigitalShowRoomRFQCustomers = '/account/catalogSearch',
  UpdateCustomer = '/account/:id',
  Transactions = '/vetsuite/transactions/search',
  Overview = '/vetsuite/overview/search',
  ContractOverview = '/vetsuite/contractOverview',
  CaptureAnalytics = '/dsanalytics/create',
  WeeklyPerformance = '/vetsuite/weeklyPerformance',
  WeeklyPerformanceContract = '/vetsuite/weeklyContractPerformance'
}
